// extracted by mini-css-extract-plugin
module.exports = {"container":"topic-details_container_1r71T","topiccontent":"topic-details_topiccontent_DAJEz","gotosupport":"topic-details_gotosupport_LMovz"};